import HomeIcon from '@/shared/assets/icons/sidebar/home.svg';
import DashboardIcon from '@/shared/assets/icons/sidebar/dashboard.svg';
import StudentIcon from '@/shared/assets/icons/sidebar/student.svg';
import StuffIcon from '@/shared/assets/icons/sidebar/stuff.svg';
import TestIcon from '@/shared/assets/icons/sidebar/test.svg';
import CertificatesIcon from '@/shared/assets/icons/sidebar/certificates.svg';
import EventIcon from '@/shared/assets/icons/sidebar/event.svg';
import ChatIcon from '@/shared/assets/icons/sidebar/chat.svg';
import CommunityIcon from '@/shared/assets/icons/sidebar/community.svg';
import CareerIcon from '@/shared/assets/icons/sidebar/career.svg';
import PushIcon from '@/shared/assets/icons/sidebar/push.svg';
import OperationsCenterIcon from '@/shared/assets/icons/sidebar/operations-center.svg';
import AdministrationIcon from '@/shared/assets/icons/sidebar/administration.svg';
import LayersIcon from '@/shared/assets/icons/sidebar/layers.svg';
import BookIcon from '@/shared/assets/icons/sidebar/book.svg';
import { SvgType } from '@/shared/types/common';
import { routerPath } from './router';

export interface IMenuItem {
  id: number;
  label: string;
  href?: string;
  icon?: SvgType;
  children?: IMenuItem[];
}

export const MENU: IMenuItem[] = [
  {
    id: 1,
    label: 'Dashboard',
    href: routerPath.main,
    icon: DashboardIcon,
  },
  {
    id: 2,
    label: 'Courses',
    href: routerPath.courses,
    icon: HomeIcon,
  },
  {
    id: 3,
    label: 'Students',
    icon: StudentIcon,
    children: [
      {
        id: 31,
        label: 'Active',
        href: routerPath.active,
      },
      {
        id: 32,
        label: 'Applicants',
        href: routerPath.applicants,
      },
      {
        id: 34,
        label: 'Profiles',
        href: routerPath.profiles,
      },
      {
        id: 33,
        label: 'Growth System',
        href: routerPath.growthSystem,
      },
    ],
  },
  {
    id: 4,
    label: 'Academic Staff',
    href: routerPath.academicStaff,
    icon: StuffIcon,
  },
  {
    id: 5,
    label: 'Assignments / Tests',
    href: routerPath.assignmentsTest,
    icon: TestIcon,
  },
  {
    id: 6,
    label: 'Certificates',
    href: routerPath.certificates,
    icon: CertificatesIcon,
  },
  {
    id: 7,
    label: 'Schedule / Events (3)',
    href: routerPath.scheduleEvents,
    icon: EventIcon,
  },
  {
    id: 8,
    label: 'Chats',
    href: routerPath.chats,
    icon: ChatIcon,
  },
  {
    id: 9,
    label: 'Community',
    href: routerPath.community,
    icon: CommunityIcon,
  },
  {
    id: 17,
    label: 'Articles',
    icon: BookIcon,
    children: [
      {
        id: 171,
        label: 'News',
        href: routerPath.articlesNews,
      },
      {
        id: 172,
        label: 'Blog',
        href: routerPath.articlesBlog,
      },
    ],
  },
  {
    id: 10,
    label: 'Career Hub',
    href: routerPath.careerHub,
    icon: CareerIcon,
  },
  {
    id: 11,
    label: 'Notifications',
    href: routerPath.pushNotifications,
    icon: PushIcon,
  },
  {
    id: 12,
    label: 'Administration',
    href: routerPath.administration,
    icon: AdministrationIcon,
  },
  {
    id: 13,
    label: 'Locations',
    href: routerPath.locations,
    icon: DashboardIcon,
  },
  {
    id: 14,
    label: 'Operations Center',
    href: routerPath.operationsCenter,
    icon: OperationsCenterIcon,
  },
  {
    id: 15,
    label: 'Payments',
    href: routerPath.payments,
    icon: BookIcon,
  },
  {
    id: 16,
    label: 'Attributes',
    icon: LayersIcon,
    children: [
      {
        id: 151,
        label: 'Categories',
        href: routerPath.attributesCategories,
      },
      {
        id: 152,
        label: 'Difficulty levels',
        href: routerPath.attributesDifficultyLevels,
      },
      {
        id: 153,
        label: 'Hashtags',
        href: routerPath.attributesHashtags,
      },
    ],
  },
];
